import api from "./api/api";

export interface GoogleCalendarStatus {
  connected: boolean;
  email: string | null;
  calendar_id: string | null;
  last_synced_at: string | null;
  sync_status: "pending" | "synced" | "error";
}

export const GoogleCalendarService = {
  getStatus: async () => {
    try {
      const res = await api.get<GoogleCalendarStatus>(
        "/reunions/google-calendar/status",
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  getAuthUrl: async () => {
    try {
      const res = await api.get<{ url: string }>(
        "/reunions/google-calendar/auth-url",
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  disconnect: async () => {
    try {
      const res = await api.delete("/reunions/google-calendar");
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  sync: async () => {
    try {
      return await api.post("/reunions/google-calendar/sync");
    } catch (error: any) {
      return error.response;
    }
  },
};
